// utilitário para formatar o nome da criança + suas turmas

const CURRENT_YEAR = new Date().getFullYear()

function truncateWithEllipsis (str, maxLength) {
  if (str.length <= maxLength) return str
  if (maxLength <= 3) return '.'.repeat(maxLength)
  return str.slice(0, maxLength - 3) + '...'
}

function sortClassrooms (classrooms) {
  return (classrooms || []).slice().sort(function (a, b) {
    return (b.is_main_classroom ? 1 : 0) - (a.is_main_classroom ? 1 : 0)
  })
}

function findFirstClassroomOfYear (classrooms, year) {
  let sorted = sortClassrooms(classrooms)
  return sorted.find(function (c) {
    return c.year === year
  })
}

export function getAllClassroomsOfYear (classrooms, year) {
  let sorted = sortClassrooms(classrooms)
  return sorted.filter(function (c) {
    return c.year === year
  })
}

function resolvePerson (item, getPerson) {
  return getPerson(item) || {}
}

export function buildShortText (items, maxLen = 48, onlyClassrooms, getPerson) {
  let parts = items.map(function (item) {
    let person = resolvePerson(item, getPerson)
    let classrooms = person.classrooms || []

    let classroom = findFirstClassroomOfYear(classrooms, CURRENT_YEAR)

    if (!classroom) {
      return person.name
    }

    return onlyClassrooms
      ? classroom.name
      : person.name + ' - ' + classroom.name
  })

  let full = parts.join(' / ')
  return truncateWithEllipsis(full, maxLen)
}

export function buildTooltipText (items, onlyClassrooms, getPerson) {
  let parts = items.map(function (item) {
    let person = resolvePerson(item, getPerson)
    let classrooms = person.classrooms || []

    let classroomsYear = getAllClassroomsOfYear(classrooms, CURRENT_YEAR)

    if (classroomsYear.length === 0) {
      return person.name
    }

    let classroomsNames = classroomsYear
      .map(function (c) {
        return c.name
      })
      .join(', ')

    return onlyClassrooms
      ? classroomsNames
      : person.name + ' - ' + classroomsNames
  })

  return parts.join(' / ')
}
